<template>
  <PonAbonents :onus=onuAbonents />
</template>

<script>
import darsan from "darsan"
import PonAbonents from "device/status/modules/pon_tree/PonAbonents.vue"

export default {
  name: "PonTreeMac",
  
  components: {PonAbonents},
  
  props: {
    state: Object,
    extra: Object,
  },
  
  data()
  {
    return {
    }
  },
  
  computed: {
    onuAbonents() 
    {
      return [ this.extra.onu ]
    },
  },
  
}
</script>

<style scoped>
.circle 
{
  font-size: x-large;
  color: lightgray;
  vertical-align: middle;
}

.star.active
{
  color: green;
}

td
{
  vertical-align: middle !important;
}

td.r
{
  text-align: right;
}
</style>